import { render } from "./CommonHeading.vue?vue&type=template&id=31578eb6&scoped=true&ts=true"
import script from "./CommonHeading.vue?vue&type=script&lang=ts"
export * from "./CommonHeading.vue?vue&type=script&lang=ts"

import "./CommonHeading.vue?vue&type=style&index=0&id=31578eb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31578eb6"]])

export default __exports__